export default __webpack_public_path__ + "static/media/eatdaburger.9a7d59d4.png";